// 歐克靈酒精稀釋計算機｜Shopify 主題 asset
// 由 theme.liquid 條件載入，僅在 /pages/alcohol-dilution-calculator 執行
// 2026-09-02｜公式：取原液量 = 總量 × 75 ÷ 原液濃度；加水 = 總量 − 原液量
(function () {
  'use strict';

  function initCalculator() {
    var root = document.querySelector('.hocl-calc');
    var concBox = document.getElementById('concOpts');
    var volBox = document.getElementById('volOpts');
    if (!root || !concBox || !volBox) return false;
    if (root.getAttribute('data-alcohol-calc-ready') === '1') return true;
    root.setAttribute('data-alcohol-calc-ready', '1');

    var state = { conc: 95, volume: 100 };

    function calc() {
      var alc = Math.max(1, Math.round(state.volume * 75 / state.conc));
      var water = Math.max(0, state.volume - alc);
      return { alc: alc, water: water };
    }

    function render() {
      var r = calc();
      document.getElementById('resConc').textContent = state.conc;
      document.getElementById('resVol').textContent = state.volume;
      document.getElementById('resAlc').textContent = r.alc;
      document.getElementById('resWater').textContent = r.water;
    }

    root.addEventListener('click', function (event) {
      var btn = event.target.closest ? event.target.closest('button.opt') : null;
      if (!btn || !root.contains(btn)) return;

      if (concBox.contains(btn) && btn.dataset.conc) {
        concBox.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.conc = Number(btn.dataset.conc);
        var cc = document.getElementById('customConc');
        if (cc) cc.value = '';
        render();
      }

      if (volBox.contains(btn) && btn.dataset.vol) {
        volBox.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.volume = Number(btn.dataset.vol);
        var cv = document.getElementById('customVol');
        if (cv) cv.value = '';
        render();
      }
    });

    var customConc = document.getElementById('customConc');
    if (customConc) customConc.addEventListener('input', function (event) {
      var value = Number(event.target.value);
      if (value >= 75 && value <= 99) {
        state.conc = value;
        concBox.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        render();
      }
    });

    var customVol = document.getElementById('customVol');
    if (customVol) customVol.addEventListener('input', function (event) {
      var value = Number(event.target.value);
      if (value > 0) {
        state.volume = value;
        volBox.querySelectorAll('.opt').forEach(function (b) { b.classList.remove('active'); });
        render();
      }
    });

    function copyResult() {
      var r = calc();
      var text = '75% 酒精調配：取 ' + r.alc + 'ml ' + state.conc + '% 酒精＋' + r.water + 'ml 純水＝' + state.volume + 'ml 75% 酒精';
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text);
      alert('✅ 配方已複製！可以貼到 Line 分享');
    }

    function shareResult() {
      var r = calc();
      var plain = '75%酒精調配：取 ' + r.alc + 'ml ' + state.conc + '% 酒精＋' + r.water + 'ml 純水';
      if (navigator.share) navigator.share({ text: plain });
      else window.open('https://line.me/R/msg/text/?' + encodeURIComponent(plain), '_blank');
    }

    var copyBtn = document.getElementById('copyBtn');
    var shareBtn = document.getElementById('shareBtn');
    if (copyBtn) copyBtn.addEventListener('click', copyResult);
    if (shareBtn) shareBtn.addEventListener('click', shareResult);

    render();
    return true;
  }

  function boot() {
    if (initCalculator()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (initCalculator() || tries >= 20) window.clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
